export const CRUNCHBASE_PEOPLE_ROLE_OPTIONS = [
  { value: "ceo", label: "CEO" },
  { value: "founder", label: "Founder" },
  { value: "board_member", label: "Board Member" },
  { value: "president", label: "President" },
  { value: "c_suite", label: "C-Suite" },
  { value: "employee", label: "Employee" },
  { value: "advisor_investor", label: "Advisor / Investor" },
  { value: "other", label: "Other" },
  { value: "no_people_data", label: "No People Data" },
];

const LABELS_BY_VALUE = new Map(
  CRUNCHBASE_PEOPLE_ROLE_OPTIONS.map((option) => [option.value, option.label])
);
const VALUES_BY_LABEL = new Map(
  CRUNCHBASE_PEOPLE_ROLE_OPTIONS.map((option) => [option.label, option.value])
);

export function getCrunchbasePeopleRoleLabel(value) {
  return LABELS_BY_VALUE.get(value) || value;
}

export function getCrunchbasePeopleRoleValue(label) {
  return VALUES_BY_LABEL.get(label) || label;
}
